<div class="tw-flex tw-flex-col tw-gap-5" [formGroup]="form">
  <p class="tw-m-0 tw-text-sm tw-text-slate-600">
    This will save your current quote as a template, saving your message content, images and attachments. Please create a name for the template below.
  </p>

  <div>
    <label class="tw-mb-2 tw-block tw-font-bold tw-text-slate-800"> Template Name<span class="tw-text-red-600">*</span> </label>
    <ate-text-input-control class="tw-rounded-lg" size="small" model-key="templateName" formControlName="templateName"> </ate-text-input-control>
  </div>
</div>
